import { Flex, HStack, Text, Icon, Image } from '@chakra-ui/react';

import LINE_PAY from '~/assets/images/LINEPay.png';

import { IoChevronForward } from 'react-icons/io5';

import * as fp from 'lodash/fp';

import { PaymentType } from '~/types/common';
import { useParams } from 'react-router-dom';

type PaymentTypeBarProps = {
  paymentType: PaymentType;
  onOpenPaymentDetailModal: () => void;
};

export default function PaymentTypeBar({
  paymentType,
  onOpenPaymentDetailModal,
}: PaymentTypeBarProps) {
  const { groupId = '', enterpriseGroupBuyId = '' } = useParams();

  const displayPaymentTypeLabel = fp.cond<PaymentType, JSX.Element | null>([
    [fp.eq(PaymentType.LINEPAY), () => <Image src={LINE_PAY} h="1.25rem" />],
    [fp.eq(PaymentType.CASH), () => <Text fontSize="sm">現金付款</Text>],
    [fp.eq(PaymentType.CREDIT), () => <Text fontSize="sm">信用卡付款</Text>],
    [
      fp.eq(PaymentType.PLATFORM),
      () => <Text fontSize="sm">{enterpriseGroupBuyId ? '企業統一付款' : '平台承擔'}</Text>,
    ],
    [fp.T, () => null],
  ]);

  return (
    <Flex justify="space-between" py={1}>
      {displayPaymentTypeLabel(paymentType)}
      {!enterpriseGroupBuyId && paymentType !== PaymentType.CASH && (
        <HStack as="button" spacing={1} onClick={onOpenPaymentDetailModal}>
          <Text color="gray.500" fontSize="xs" fontWeight="bold">
            展開明細
          </Text>
          <Icon color="gray.500" as={IoChevronForward} />
        </HStack>
      )}
    </Flex>
  );
}
